// client-web-appsuite/src/constants/option.js

let OPTION = {

    // CARD IMPORT
    IMPORT_DROP: { 
        id: 'import_drop', 
        label: 'drag & drop',
        icon: null,
        description: (subject) => `drag and drop your ${subject} here`
    },
    IMPORT_UPLOAD: { 
        id: 'import_upload', 
        label: 'upload',
        icon: 'fa-solid fa-upload',
        description: (subject) => `upload ${subject}`
    },
    IMPORT_LIBRARY: { 
        id: 'import_library', 
        label: 'library',
        icon: 'fa-solid fa-book',
        description: (subject) => `choose ${subject}`
    },
    IMPORT_PHOTO: { 
        id: 'import_photo', 
        label: 'photo',
        icon: 'fa-solid fa-camera',
        description: (subject) => 'take photo'
    },


    // CARD SELECT FLOW
    SELECT_FLOW_PROMPT: { 
        id: 'select_flow_prompt',
        icon: 'fa-solid fa-font',
        label: 'prompt',
        description: 'describe your idea',
        guidance: 'Great when you have an initial idea but no visual reference.'
    },
    SELECT_FLOW_IMAGES: { 
        id: 'select_flow_images', 
        icon: 'fa-solid fa-images',
        label: 'images',
        description: 'import your images',
        guidance: 'Best if you already have images of what you want to create.'
    },
    SELECT_FLOW_SKETCH: { 
        id: 'select_flow_sketch', 
        icon: 'fa-solid fa-pencil', 
        label: 'sketch', 
        description: 'sketch it yourself',
        guidance: 'Perfect when you want full creative control by drawing your own design.'
    },

    // CARD SELECT TEXTURE
    SELECT_TEXTURE_GENERATE: {
        id: 'select_texture_generate',
        icon: 'fa-solid fa-brush',
        label: 'continue',
        description: 'use existing image',
        guidance: 'Use the existing model image to create the texture.'
    },
    SELECT_TEXTURE_PROMPT: {
        id: 'select_texture_prompt',
        icon: 'fa-solid fa-font',
        label: 'prompt',
        description: 'describe your texture',
        guidance: 'Create a new texture from a text description.'
    },
    SELECT_TEXTURE_IMAGE: {
        id: 'select_texture_image',
        icon: 'fa-solid fa-image',
        label: 'image',
        description: 'import your reference',
        guidance: 'Import an image as the texture reference.'
    },


    // CARD GENERATE GEOMETRY
    GENERATE_GEOMETRY_SOLID: {
        id: 'generate_geometry_solid', 
        url: '/images/examples/generate_geometry_solid.png',
        label: '<b>solid</b> geometry',
        guidance: 'Generates closed, watertight models with real volume'
    },
    GENERATE_GEOMETRY_SURFACE: {
        id: 'generate_geometry_surface',
        url: '/images/examples/generate_geometry_surface.png',
        label: '<b>surface</b> geometry',
        guidance: 'Generates open surfaces with interior and holes'
    },

    // CARD GENERATE TEXTURE
    GENERATE_TEXTURE_NATIVE: {
        id: 'generate_texture_native',
        url: '/images/examples/generate_texture_native.png',
        label: '<b>native</b> texture',
        guidance: 'Native PBR-texture generation with full model coverage'
    },
    GENERATE_TEXTURE_PROJECT: {
        id: 'generate_texture_project',
        url: '/images/examples/generate_texture_project.png',
        label: '<b>projected</b> texture',
        guidance: 'Projection-based color-texture generation from multiple views'
    },
    GENERATE_TEXTURE_HYBRID: {
        id: 'generate_texture_hybrid',
        url: '/images/examples/generate_texture_hybrid.png',
        label: '<b>hybrid</b> texture',
        guidance: 'Hybrid PBR-texture generation combining native and projected methods'
    }
}

OPTION = Object.freeze(OPTION)

export default OPTION